<template>
  <!-- tx -->
  <div class="layout">
    <h2 class="ta-center">Search</h2>
    <section class="section section--option">
      <span>Enter hash to search</span>
    </section>
    <section class="section">
      <div class="section__meta">
        <label class="search">
          <input v-model="inputTxValue" class="transition-primary" :disabled="txSearchLoading" type="text"
            placeholder="0xAC3A4ADE5AF21FDC18B3FA34271696FA8AC9153F59D8F95F5BC5B452D8DC0D3B" />
          <button @click="searchTxItem()" class="search-button transition-primary" type="button" name="button">
            <svg v-if="!txSearchLoading" xmlns="http://www.w3.org/2000/svg" width="11.819" height="11.819"
              viewBox="0 0 11.819 11.819">
              <path
                d="M13.535,12.528,10.91,9.909a4.991,4.991,0,1,0-1,1l2.619,2.625a.712.712,0,0,0,1.006,0h0a.712.712,0,0,0,0-1.006Zm-6.6-2.042a3.532,3.532,0,1,1,3.532-3.532,3.532,3.532,0,0,1-3.532,3.532Z"
                transform="translate(-1.924 -1.924)" />
            </svg>
            <svg v-else class="search-loader" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100"
              enable-background="new 0 0 0 0" xml:space="preserve">
              <path fill="#fff"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50"
                  to="360 50 50" repeatCount="indefinite" />
              </path>
            </svg>
          </button>
        </label>
      </div>
    </section>
  </div>
  <Hint v-model:show="hintVisible">
    <p>{{ hintText }}</p>
  </Hint>
</template>

<script>
// @ is an alias to /src
import { ref } from 'vue';
import axios from 'axios';
import netsAvalible from '@/store/nets.js';
import { globalMethodsMixin } from '@/mixins/globalMethodsMixin';

export default {
  mixins: [globalMethodsMixin],
  data() {
    return {
      hintVisible: false,
      hintText: 'Error',
      txSearchLoading: false,
      inputTxValue: '',
      
      // tx
      dialogTxVisible: false,
      dialogTxValue: '',
      selectedTxNet: 'Backbone',
      txDetails: new Map(),

      // balance
      dialogBalanceVisible: false,
      balanceLoading: false,
      Balance: [],

      monthNames: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],

      // base urls
      txUrl: 'https://1.api.explorer.cellframe.net/expl'
    };
  },

  props: {
    size: {
      type: Number,
      required: false,
      default: 5
    }
  },

  created() {
    if (this.$route.query.selectedTxNet) {
      this.selectedTxNet = this.$route.query.selectedTxNet;
    }
  },

  methods: {

    async searchTxItem() {
      if (this.txSearchLoading) {
        return;
      }

      if (!this.isValidHash(this.inputTxValue)) {
        this.hintText = 'Invalid hash format';
        this.showHint();
        return;
      }

      this.txSearchLoading = true;

      try {
        // Добавляем задержку с Promise вместо setTimeout
        await new Promise(resolve => setTimeout(resolve, 1000));

        const response = await axios.get(
          `https://2.api.explorer.cellframe.net/search/${this.inputTxValue}`,
          {
            // Настраиваем axios для выброса ошибок при 4xx и 5xx статусах
            validateStatus: function (status) {
              return status >= 200 && status < 300; // Только 2xx статусы считаются успешными
            }
          }
        );

        console.log(response.data);

        // Проверяем успешный ответ и наличие результатов
        if (response.data && response.data.results && response.data.total_found > 0) {
          // Перенаправляем на страницу результатов поиска
          this.$router.push(`/search-results/${this.inputTxValue}`);
        } else {
          // Если результатов нет
          this.hintText = 'No results found for this hash';
          this.showHint();
        }
      } catch (error) {
        if (error.response) {
          this.hintText = `HTTP Error ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
          // Запрос был отправлен, но ответа не получено
          this.hintText = 'Network error: No response received';
        } else {
          // Ошибка при настройке запроса
          this.hintText = error.msg || 'An error occurred';
        }

        this.showHint();
      } finally {
        this.txSearchLoading = false;
      }
    },

    isValidHash(hash) {
      const hashRegex = /^0x([A-Fa-f0-9]{64})$/;
      return hashRegex.test(hash);
    },

    showTxDialog() {
      this.dialogTxVisible = true;
    },

    showHint() {
      this.hintVisible = true;

      setTimeout(() => {
        this.hintVisible = false;
      }, 2000);
    }
  },

  mounted() {
    this.txUrl = this.nets.get(this.selectedTxNet).url;
  },

  setup() {
    const nets = ref(netsAvalible);
    return { nets };
  },

  watch: {
    selectedTxNet() {
      this.txUrl = this.nets.get(this.selectedTxNet).url;
    }
  }
};
</script>

<style scoped>
@import '../assets/css/layout.css';
@import '../assets/css/pagination.css';

.layout {
  width: 100%;
  padding: 0 16px 48px;
}

.layout--hidden {
  display: none;
}

.layout:first-child {
  margin: 48px 0 0;
}

.table--event .hash__wrap span {
  width: 100%;
}

.hash__wrap .hash__primary,
.hash__wrap .hash__pseudo {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.hash__wrap .hash__pseudo {
  color: var(--color-bg-primary);
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.table--transaction .hash__wrap .value {
  margin: 0 0 0 auto;
}

.table__button {
  display: flex;
}

.table__link {
  text-decoration: none;
  text-align: center;
  width: 100%;
  padding: 8px 32px;
  color: var(--color-text-primary);
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 9px;
  cursor: pointer;
}

.table__link:hover {
  color: var(--color-accent-primary);
  background-color: var(--color-bg-secondary-light);
}

@media screen and (max-width: 767.7px) {
  .hash__wrap .hash__pseudo {
    position: relative;
  }

  .hash__wrap .hash__primary {
    position: absolute;
  }

  .table--transaction .hash__wrap span {
    width: 88%;
  }
}

@media screen and (min-width: 768px) {
  table {
    position: relative;
  }

  tbody {
    width: 100%;
    height: 100%;
    min-height: 336px;
  }

  .hash__wrap .hash__primary,
  .hash__wrap .hash__pseudo {
    position: absolute;
  }

  .table--transaction .hash__wrap span {
    width: 90%;
  }

  .timestamp {
    min-width: 210px;
  }
}
</style>
